import React, { useEffect, useState } from "react"
import { formatDateDataGrid } from "src/utils/format-date"
import PropTypes from 'prop-types'
import dayjs from "dayjs"
import { DATE_FORMAT } from "src/utils/constants"
import DatalakeService from "src/services/datalake-service"
import ParameterPaginationTable from "src/components/table/parameter-pagination-table"

const ParameterDatalakeB3AcoesNegAnaliticoTable = (props) => {
    const dataLakeService = new DatalakeService()
    const [data, setData] = useState([])
    const [pagination, setPagination] = useState({ count: 0, next: null, previous: null })

    useEffect(() => {
        loadData()
    }, [])

    const loadData = () => {
        props.loading(true)
        dataLakeService.loadPaginationEndpoint(props.endpoint).then((response) => {
            props.loading(false)

            const { body } = response
            const { results, count, next, previous } = body
            const list = results.map((obj, index) => ({ ...obj, id: index }))

            setPagination({ count, next, previous })
            setData(list)
        })
    }

    const createRow = async () => {
        const body = {
            Ticker: "N/A",
            DataReferencia: dayjs().format(DATE_FORMAT),
            DataNegocio: dayjs().format(DATE_FORMAT),
            HoraFechamento: "00:00:00",
            AcaoAtualizacao: 0,
            PrecoNegociado: 0,
            QtNegociada: 0,
            CodNegocio: 0,
            TipoSessaoPregao: 0,
            CodComprador: 0,
            CodVendedor: 0,
            TipoCanal: 0
        }


        props.loading(true)
        return dataLakeService.createTableEndpoint(props.endpoint, body)
            .then(() => {
                props.loading(false)
                loadData(0, 25)
            })
            .catch((err) => {
                props.loading(false)
                throw err
            })
    }

    const updateRow = async (newRow) => {
        const {
            ID,
            Ticker,
            DataReferencia,
            DataNegocio,
            HoraFechamento,
            AcaoAtualizacao,
            PrecoNegociado,
            QtNegociada,
            CodNegocio,
            TipoSessaoPregao,
            CodComprador,
            CodVendedor,
            TipoCanal
        } = newRow

        const body = {
            Ticker,
            DataReferencia,
            DataNegocio,
            HoraFechamento,
            AcaoAtualizacao,
            PrecoNegociado,
            QtNegociada,
            CodNegocio,
            TipoSessaoPregao,
            CodComprador,
            CodVendedor,
            TipoCanal
        }

        props.loading(true)
        return dataLakeService.updateTableEndpoint(props.endpoint, ID, body)
            .then(() => {
                props.loading(false)
            })
            .catch((err) => {
                props.loading(false)
                throw err
            })
    }

    const deleteRow = async (row) => {
        props.loading(true)
        const { ID } = row

        return dataLakeService.deleteTableEndpoint(props.endpoint, ID)
            .then(() => {
                props.loading(false)
                const listRemoved = data.filter((item) => item.ID !== ID)
                setData(listRemoved)
            })
            .catch((err) => {
                props.loading(false)
                throw err
            })
    }

    const onFilter = async (filterList, limit, offset) => {
        const query = filterList
            .map(obj => `${encodeURIComponent(obj.field)}=${encodeURIComponent(obj.value)}`)
            .join('&')

        props.loading(true)
        dataLakeService.loadPaginationEndpoint(props.endpoint, query, limit, offset)
            .then((response) => {
                props.loading(false)

                const { body } = response
                const { results, count, next, previous } = body
                const list = results.map((obj) => ({ ...obj, id: obj.ID }))

                setPagination({ count, next, previous })
                setData(list)
            })
    }

    const changePage = async (endpoint) => {
        props.loading(true)
        dataLakeService.paginate(endpoint).then((response) => {
            props.loading(false)

            const { body } = response
            const { results, count, previous, next } = body
            const list = results.map((obj) => ({ ...obj, id: obj.ID }))

            setPagination({ count, next, previous })
            setData([])
            setData(list)
        })
    }

    const columns = [
        {
            field: 'ID',
            headerName: '#',
            disableColumnMenu: true,
            disableFilter: true,
            flex: true,
            minWidth: 80,
        },
        {
            field: 'Ticker',
            headerName: 'Ticker',
            disableColumnMenu: true,
            flex: true,
            minWidth: 120
        },
        {
            field: 'DataReferencia',
            headerName: 'DataReferencia',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'date',
            valueGetter: ({ value }) => (value ? new Date(value) : null),
            valueFormatter: ({ value }) =>
                value instanceof Date && !isNaN(value)
                    ? dayjs(value).format(DATE_FORMAT)
                    : '',
        },
        {
            field: 'DataNegocio',
            headerName: 'DataNegocio',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'date',
            valueGetter: ({ value }) => (value ? new Date(value) : null),
            valueFormatter: ({ value }) =>
                value instanceof Date && !isNaN(value)
                    ? dayjs(value).format(DATE_FORMAT)
                    : '',
        },
        {
            field: 'HoraFechamento',
            headerName: 'HoraFechamento',
            disableColumnMenu: true,
            flex: true,
            minWidth: 140,
            type: 'string'
        },
        {
            field: 'AcaoAtualizacao',
            headerName: 'AcaoAtualizacao',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'PrecoNegociado',
            headerName: 'PrecoNegociado',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'QtNegociada',
            headerName: 'QtNegociada',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'CodNegocio',
            headerName: 'CodNegocio',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'TipoSessaoPregao',
            headerName: 'TipoSessaoPregao',
            disableColumnMenu: true,
            flex: true,
            minWidth: 180,
            type: 'number'
        },
        {
            field: 'CodComprador',
            headerName: 'CodComprador',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'CodVendedor',
            headerName: 'CodVendedor',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'TipoCanal',
            headerName: 'TipoCanal',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'CriadoEm',
            headerName: 'Data de Criação',
            flex: true,
            minWidth: 150,
            disableColumnMenu: true,
            disableFilter: true,
            renderCell: (params) => formatDateDataGrid(params)
        },
        {
            field: 'AtualizadoEm',
            headerName: 'Data de Atualização',
            flex: true,
            minWidth: 150,
            disableColumnMenu: true,
            disableFilter: true,
            renderCell: (params) => formatDateDataGrid(params)
        }
    ]

    return (
        <ParameterPaginationTable
            columns={columns}
            data={data}
            setData={setData}
            createRow={createRow}
            deleteRow={deleteRow}
            updateRow={updateRow}
            filterFunction={onFilter}
            pagination={pagination}
            onChangePage={changePage}
            customFilter={true}
        />
    )
}

ParameterDatalakeB3AcoesNegAnaliticoTable.propTypes = {
    loading: PropTypes.func,
    endpoint: PropTypes.string,
}

export default ParameterDatalakeB3AcoesNegAnaliticoTable
